import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { AppConfig } from './app-config';
import { FunctionService } from './provider/function.service';

@Injectable()
export class AppService {

  private config = new AppConfig();

  constructor(
    private http: HttpClient,
    private functionService: FunctionService,
  ) { }

  public postData(data: object, method: string): Observable<object> {

    return this.http.post(this.config.app_host + method, this.functionService.formatData(data), {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded'),
      responseType: 'json'
    });
  }

  public getData(data: any, method: string): Observable<object> {

    return this.http.get(this.config.app_host + method, {
      responseType: 'json',
      params: data
    });
  }
}



// WEBPACK FOOTER //
// /var/www/minha-jnnet/src/app/app.service.ts